import { useApplicationContext } from '../context/ApplicationContext';

/**
 * Custom hook for permission checking
 * @returns {Object} { hasPermission: (permission) => boolean }
 */
export function usePermission() {
  const { user, permissions } = useApplicationContext();

  const hasPermission = (permission) => {
    // Super Admin (user_type 1) has all permissions
    if (user?.user_type === 1) return true;
    
    if (!permissions) return false;
    
    return permissions.includes(permission);
  };

  return { hasPermission };
}

export default usePermission;
